import { render, staticRenderFns } from "./productManageCommission.vue?vue&type=template&id=16b0bd6b&scoped=true"
import script from "./productManageCommission.vue?vue&type=script&lang=js"
export * from "./productManageCommission.vue?vue&type=script&lang=js"
import style0 from "./productManageCommission.vue?vue&type=style&index=0&id=16b0bd6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b0bd6b",
  null
  
)

export default component.exports